import { render, staticRenderFns } from "./timeLimit.vue?vue&type=template&id=ece1c9de&scoped=true"
import script from "./timeLimit.vue?vue&type=script&lang=js"
export * from "./timeLimit.vue?vue&type=script&lang=js"
import style0 from "./timeLimit.vue?vue&type=style&index=0&id=ece1c9de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece1c9de",
  null
  
)

export default component.exports